import { DRIVER_LICENSE_ENDPOINTS } from "@/config/api";
import { httpClient, type ApiResponse } from "@/lib/http";

import type {
    DriverLicenseRequeuePayload,
    DriverLicenseReviewPayload,
    DriverLicenseReviewResult,
    DriverLicenseVerificationDetails,
    DriverLicenseVerificationQueryParams,
    DriverLicenseVerificationQueue,
} from "../types";

const buildQueueQueryString = (
    params: DriverLicenseVerificationQueryParams
) => {
    const query = new URLSearchParams();

    if (params.page !== undefined) query.set("page", params.page.toString());
    if (params.size !== undefined) query.set("size", params.size.toString());
    if (params.driverId) query.set("driverId", params.driverId);
    if (params.statuses?.length) query.set("statuses", params.statuses.join(","));

    return query.toString();
};

export const getDriverLicenseVerifications = async (
    params: DriverLicenseVerificationQueryParams = {}
) => {
    const queryString = buildQueueQueryString(params);
    const url = queryString
        ? `${DRIVER_LICENSE_ENDPOINTS.QUEUE}?${queryString}`
        : DRIVER_LICENSE_ENDPOINTS.QUEUE;

    const { data } = await httpClient.get<ApiResponse<DriverLicenseVerificationQueue>>(url);
    return data;
};

export const getDriverLicenseVerification = async (verificationId: string) => {
    const { data } = await httpClient.get<ApiResponse<DriverLicenseVerificationDetails>>(
        DRIVER_LICENSE_ENDPOINTS.DETAILS(verificationId)
    );

    return data;
};

export const reviewDriverLicenseVerification = async (
    verificationId: string,
    payload: DriverLicenseReviewPayload
) => {
    const { data } = await httpClient.post<ApiResponse<DriverLicenseReviewResult>>(
        DRIVER_LICENSE_ENDPOINTS.REVIEW(verificationId),
        payload
    );

    return data;
};

export const requeueDriverLicenseVerification = async (
    verificationId: string,
    payload: DriverLicenseRequeuePayload = {}
) => {
    const { data } = await httpClient.post<ApiResponse<DriverLicenseReviewResult>>(
        DRIVER_LICENSE_ENDPOINTS.REQUEUE(verificationId),
        payload
    );

    return data;
};
